import { render, staticRenderFns } from "./ModuleValidator.vue?vue&type=template&id=270cd278&"
import script from "./ModuleValidator.vue?vue&type=script&lang=js&"
export * from "./ModuleValidator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports